import React, { memo } from 'react';

import { makeStyles } from '@mui/styles';
import SvgIcon from '@mui/material/SvgIcon';

const useStyles = makeStyles(({ typography }) => {
  const size = typography.pxToRem(12);
  return {
    icon: {
      width: size,
      height: size,
    },
  };
});

const ConsolidatedIcon = () => {
  const styles = useStyles();

  return (
    <SvgIcon viewBox="0 0 12 12" className={styles.icon}>
      <g id="g">
        <rect width="12" height="12" fill="#A90034" />
        <path
          d="M9.23877 7.39502C9.1779 8.23649 8.86637 8.89893 8.3042 9.38232C7.74561 9.86572 7.00798 10.1074 6.09131 10.1074C5.0887 10.1074 4.29915 9.77083 3.72266 9.09766C3.14974 8.4209 2.86328 7.49349 2.86328 6.31543V5.8374C2.86328 5.08545 2.99577 4.42301 3.26074 3.8501C3.52572 3.27718 3.90348 2.83854 4.39404 2.53418C4.88818 2.22624 5.4611 2.07227 6.11279 2.07227C7.01514 2.07227 7.74202 2.31396 8.29346 2.79736C8.84489 3.28076 9.16357 3.95931 9.24951 4.83301H7.63818C7.5988 4.32812 7.45736 3.96289 7.21387 3.7373C6.97396 3.50814 6.60693 3.39355 6.11279 3.39355C5.57568 3.39355 5.17285 3.58691 4.9043 3.97363C4.63932 4.35677 4.50326 4.95296 4.49609 5.76221V6.35303C4.49609 7.19808 4.62321 7.81576 4.87744 8.20605C5.13525 8.59635 5.53988 8.7915 6.09131 8.7915C6.58903 8.7915 6.95964 8.67871 7.20312 8.45312C7.4502 8.22396 7.59163 7.87126 7.62744 7.39502H9.23877Z"
          fill="white"
        />
      </g>
    </SvgIcon>
  );
};

export default memo(ConsolidatedIcon);
